import {
  AddressInput,
  DatePicker,
  InputText,
  InputTextArea,
  PhoneNumberField,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { AddressDetails } from "../../components/AddressInput";

function PurchaseDetails() {
  const { control, setValue } = useFormContext();
  return (
    <div className="space-y-3">
      <InputText
        control={control}
        name="purchaseDetails.invoice"
        required
        label="Invoice"
      />
      <DatePicker
        control={control}
        name="purchaseDetails.date_of_purchase"
        required
        placeholder="Date of Purchase"
        label="Date of Purchase"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_name"
        required
        label="Store Name"
      />
      <PhoneNumberField
        control={control}
        name="purchaseDetails.store_phone"
        required
        label="Store Phone"
      />
      <AddressInput
        control={control}
        name="purchaseDetails.store_address"
        onAddressSelect={(address: AddressDetails) => {
          setValue("purchaseDetails.store_city", address.city);
          setValue("purchaseDetails.store_state", address.state);
          setValue("purchaseDetails.store_zip", address.zipCode);
        }}
        required
        label="Store Address"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_city"
        required
        label="Store City"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_state"
        required
        label="Store State"
      />
      <InputText
        control={control}
        name="purchaseDetails.store_zip"
        required
        label="Store Zip code"
      />
      <InputTextArea
        control={control}
        name="purchaseDetails.were_any_items_exchanged"
        required
        label="Were any items exchanged"
      />
    </div>
  );
}

export default PurchaseDetails;
